//noScroll
class ScrollHeader {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    window.addEventListener("scroll", function () {
      const header = document.querySelector(".c-header");
      header.classList.toggle("is-scroll", window.scrollY > 50);
    });
  }
}
